import { Col, Form, Input, Modal, Row, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import UnifiedInput from '../../../components/ReportFormGenerator/UnifiedInput/UnifiedInput';
import SelectSearchInput from './SelectSearchInput';
import { LoadingOutlined } from "@ant-design/icons";
import liracrypt from '../../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../../components/ApiErrorComp/ApiErrorComp';
import { useSelector } from 'react-redux';
import StAddNew from '../../DSeries/StAddNew';


const NewGenerateIssue = (props) => {
    const currentAndonStatus = useSelector(state => state.andonStatus);
    const [loading, setLoading] = useState(false);
    const antIcon = <LoadingOutlined style={{ fontSize: 20 }} spin />;
    const [load, setLoad] = useState(false);
    const [loadStable, setLoadStable] = useState(false);
    const [updateStable, setUpdateStable] = useState(false);
    const [rmrk, setRmrk] = useState("");
    const cancelBtnRef = useRef();
    const [smodalForm] = Form.useForm();
    const [form] = Form.useForm();
    const [listDropDownVal, setListDropdownVal] = useState("");
    const [selectedAndon, setSelectedAndon] = useState();
    const [flowIndex, setFlowIndex] = useState();
    const [smodalTitle, setSmodalTitle] = useState("");
    const [generatedAndon, setGeneratedAndon] = useState({
        "lid": {
            key: props.selectedLid,
            val: ""
        }
    });
    const [smodalData, setSmodalData] = useState();
    const [currentStep, setCurrentStep] = useState();
    const [showSmodal, setShowSmodal] = useState(false);
    const [selectedVal, setSelectedVal] = useState();


    useEffect(() => {
        if (!props.isAndonCall) {
            let __generatedAdon = { ...props.addonstatus?.andonDict };
            let selectedPid = __generatedAdon?.pid;
            if (selectedPid) {
                let _selectedAndon = props.settingValues["paramInfo"][selectedPid.key];
                setSelectedAndon(_selectedAndon);
                Object.keys(__generatedAdon).forEach(y => {
                    if (!__generatedAdon[y].val) {
                        delete __generatedAdon[y];
                    }
                })
                setGeneratedAndon(__generatedAdon);
                let _selectedVal = {}
                Object.keys(__generatedAdon).map(x => {
                    if (x === 'lid' || x === 'pid') {
                        return;
                    }
                    let label = _selectedAndon[x]?.label || x;
                    if (label && __generatedAdon[x]?.val) {
                        _selectedVal[label] = __generatedAdon[x]?.val;
                    }
                });
                setSelectedVal(_selectedVal);
                if (props.addonstatus.currentAndonStage !== 'start') {
                    let btnTextModes = ['acknowledgeMode', 'runMode', 'endMode'];
                    let currentIndex = _selectedAndon?.flow?.findIndex(x => x === props.addonstatus.currentAndonStage);
                    let nextMode = _selectedAndon?.flow[currentIndex + 1];
                    if (btnTextModes.includes(nextMode)) {
                        setFlowIndex(currentIndex + 2);
                    } else {
                        setFlowIndex(currentIndex + 1);
                    }
                } else {
                    setFlowIndex(0);
                }
            }
        }
    }, [])

    useEffect(() => {
        if (selectedAndon) {
            let step = selectedAndon?.flow[flowIndex];
            if (step) {
                setCurrentStep(selectedAndon[step]);
                if (selectedAndon[step]?.src === 'smodal' || selectedAndon[step]?.src === 'static') {
                    setShowSmodal(true);
                }
            } else {
                setCurrentStep(null);
            };
        }
    }, [flowIndex]);


    const handleAndonSelected = (val) => {
        setSelectedAndon(props.settingValues["paramInfo"][props.settingValues["paramName"][val]]);
        setGeneratedAndon({
            ...generatedAndon,
            'pid': {
                key: props.settingValues["paramName"][val],
                val: val
            },
        });
        setFlowIndex(0);
    };

    const handleOk = () => {
        return currentStep?.src === 'smodal' ?
            smodalForm.submit() :
            (
                setShowSmodal(false),
                setFlowIndex(flowIndex + 1)
            );
    }

    const handleCancel = () => {
        setShowSmodal(false);
        setFlowIndex(flowIndex - 1);
    };

    const onFinish = () => {
        setLoading(true);
        let currentFlow = selectedAndon.flow[flowIndex];
        let currentStepVal = { ...generatedAndon[currentFlow] };
        currentStepVal.rmrk = form.getFieldValue("rmrk");
        setGeneratedAndon({
            ...generatedAndon,
            [currentFlow]: currentStepVal
        });
        form.resetFields(['rmrk']);
        setFlowIndex(flowIndex + 1);
        setLoading(false);
    }

    const onDynamicDropdownChange = (val, dynamicId) => {
        let currentFlow = selectedAndon.flow[flowIndex];
        setGeneratedAndon({
            ...generatedAndon,
            [currentFlow]: {
                val,
                key: dynamicId ? dynamicId : val,
                rmrk: form.getFieldValue('rmrk')
            },
        });
        setSelectedVal({
            ...selectedVal,
            [currentStep?.label]: dynamicId ? dynamicId : val,
        });
    };

    const getNameByVal = (val) => {
        return currentStep?.list?.find(x => x._id === val)?.name;
    }

    const onListChange = (val) => {
        setListDropdownVal("");
        let currentFlow = selectedAndon.flow[flowIndex];
        setGeneratedAndon({
            ...generatedAndon,
            [currentFlow]: {
                key: val,
                val: getNameByVal(val),
                rmrk: form.getFieldValue('rmrk')
            },
        });
        setSelectedVal({
            ...selectedVal,
            [currentStep?.label]: getNameByVal(val)
        });
    };

    const rmrkInput =
        (currentStep?.isCommentable && generatedAndon[selectedAndon.flow[flowIndex]]) && (
            <Form.Item
                name={"rmrk"}
                rules={[
                    {
                        required: (generatedAndon && generatedAndon[selectedAndon.flow[flowIndex]]?.val === 'Others'),
                        message: 'Please Enter Comment'
                    }
                ]}
            >
                <Input placeholder="Enter Comment" />
            </Form.Item>
        )

    const dynamicDropDown = (
        <>
            <div
                className="AuditSection CreateAudit"
                style={{ padding: 5 }}
            >
                <div className="ThemeForm">
                    <Form
                        name="ReportForm"
                        form={form}
                        layout="horizontal"
                        colon={false}
                        onFinish={onFinish}
                    >
                        <UnifiedInput
                            labelAsVal={true}
                            extraData={{ lid: props.selectedLid }}
                            form={form}
                            colSpan={24}
                            multiSelect={false}
                            typ="dropDown"
                            url={currentStep?.api?.source}
                            disabled={false}
                            source={"dynamic"}
                            sourceParams={{
                                ...currentStep?.api?.sourceParams,
                                ...generatedAndon,
                                ...smodalData,
                                lid: props.selectedLid,
                                pid: selectedAndon?.sourceParams?.pid,
                            }}
                            pname={currentStep?.label}
                            name={currentStep?.label}
                            label={currentStep?.label}
                            errorMessage={currentStep?.placeHolder}
                            required={true}
                            placeholder={currentStep?.label}
                            defaultValue={""}
                            searchable={true}
                            includeAll={false}
                            auxOnChange={onDynamicDropdownChange}
                        />
                        {rmrkInput}
                    </Form>
                </div>
            </div>
        </>
    );

    const listDropDown = (
        <div
            className="AuditSection CreateAudit"
            style={{ padding: 5 }}
        >
            <div className="ThemeForm">
                <Form
                    name="ReportForm"
                    form={form}
                    layout="horizontal"
                    colon={false}
                    onFinish={onFinish}
                //    size="large"
                >
                    <Col span={24}>
                        <div className="selectBoxContainer">
                            <Form.Item
                                name={selectedAndon?.flow[flowIndex]}
                                label={currentStep?.label}
                                style={{ marginRight: "10px", fontWeight: 600 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select " + currentStep?.label,
                                    },
                                ]}
                            >
                                <Select
                                    required
                                    value={listDropDownVal}
                                    placeholder={currentStep?.placeHolder}
                                    className="selectBox"
                                    onChange={onListChange}
                                >
                                    {currentStep?.list?.map((x, i) => (
                                        <Select.Option key={i} value={x._id}>
                                            {x.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </Col>

                    {rmrkInput}
                </Form>
            </div>
        </div>
    )

    const getNextStep = () => {
        if (currentStep?.src === 'list') {
            return listDropDown;
        };
        if (currentStep?.src === 'api') {
            return dynamicDropDown;
        };

    };

    const submitData = () => {
        setLoad(true);
        setUpdateStable(!updateStable);
        liracrypt.post(currentStep?.api, {
            "andonDict": generatedAndon,
            "smodal": smodalData,

        }).then(({ data }) => {
            let nextModeBtnText;
            if (currentStep?.nextMode === 'acknowledgeMode') {
                nextModeBtnText = 'Acknowledge Mode';
            };
            if (currentStep?.nextMode === 'endMode') {
                nextModeBtnText = 'Andon Call';
            };
            if (currentStep?.nextMode === 'runMode') {
                nextModeBtnText = 'Run Mode';
            };
            props.changeMode(nextModeBtnText);
            setLoad(false);
        }).catch(err => {
            ApiErrorComp(err);
            console.error(err);
            setLoad(false);
        })
    }

    const onCallFinish = (data) => {
        let currentFlow = selectedAndon.flow[flowIndex];
        setSmodalData({
            ...smodalData,
            [currentFlow]: data
        });
        setShowSmodal(false);
        setFlowIndex(flowIndex + 1);
    }

    return (
        <>
            <Modal
                title={smodalTitle}
                open={showSmodal}
                onOk={handleOk}
                cancelButtonProps={{ hidden: currentStep?.src === 'static' }}
                onCancel={currentStep?.src === 'static' ? handleOk : handleCancel}
                width="60%"
            >
                {
                    currentStep?.src === 'smodal' ?
                        <StAddNew
                            setSmodalTitle={title => setSmodalTitle(title)}
                            initForm={smodalForm}
                            colSpan={24}
                            urlEndpoint={currentStep?.smodal?.urlEndpoint}
                            extraData={{ lid: props.selectedLid }}
                            dictName={currentStep?.smodal?.dictName}
                            pageName={currentStep?.smodal?.pageName}
                            onFormSubmit={onCallFinish}
                        /> :
                        <p style={{
                            color: "#ffffff",
                            textAlign: "center",
                            fontSize: 16
                        }}>{currentStep?.static}</p>
                }

            </Modal>
            <div className="Andon">
                <Row>
                    {/* <Col span={24}>
                        <div className="LineContainer" style={{ textAlign: "center" }}>
                            <div
                                style={{
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    marginLeft: "2px",
                                    marginBottom: "5px",
                                    textAlign: "initial",
                                }}
                            >
                                Andon Status
                            </div>
                            <div style={{ marginTop: "7px", width: "100%" }}>
                                {" "}
                                <p
                                    className={`txtInfo andonStatus ${getBgColor()}`}
                                    style={{
                                        borderRadius: "7px",
                                        minWidth: "100%",
                                        color: "#fff",
                                        textAlign: "center",
                                        backgroundColor: "#3b3b3b",
                                        fontSize: "30px",
                                        paddingTop: "10px",
                                        paddingBottom: "10px",
                                        fontWeight: 600,
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <span
                                        className={`txtInfo andonStatus ${getBgColor()}`}
                                        style={{
                                            fontWeight: 600,
                                            fontSize: "30px",
                                            textTransform: "uppercase",
                                        }}
                                    >
                                        {props.addonstatus?.andonDict?.pid?.val}
                                    </span>
                                </p>
                            </div>
                        </div> 
                        <div className="generatedAndonList">
                            <StablePrime showNoData={false} updateStable={updateStable} autoUpdate={true} editSingleColumn={true} zenTable={true} url={'/linedash/andonstatustable'} data={{ lid: props.selectedLid }} identity="DataTable" />
                        </div>

                    </Col> */}
                    <Col xs={24} sm={24} md={24} lg={24} style={{ padding: "10px" }}>
                        {
                            (props.isAndonCall && !currentStep) && (
                                <div className="selectBoxContainer">
                                    <label style={{ fontWeight: 600, marginBottom: "5px" }}>
                                        Select Andon
                                    </label>
                                    <SelectSearchInput
                                        keyValue={null}
                                        value={null}
                                        data={props.settingValues.paramList}
                                        placeholder="Search an Andon..."
                                        callBackSetValue={handleAndonSelected}
                                    />
                                </div>
                            )
                        }
                        {
                            loading ? <></> :
                                <>
                                    {getNextStep()}
                                </>
                        }
                    </Col>
                </Row>
                <Row className='test' style={{ marginBottom: 10, minHeight: 180, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                        <div className="bottom" style={{ display: "inline-block" }}>
                            {currentStep?.src === 'button' ? (
                                <>
                                    {/* {console.log(andon)} */}
                                    <button
                                        disabled={load}
                                        style={{
                                            fontWeight: 600,
                                            backgroundColor: "#149414",
                                            borderRadius: "7px",
                                        }}
                                        className="btn-mnx"
                                        onClick={submitData}
                                    >
                                        {load ? antIcon : currentStep?.label}
                                    </button>
                                </>
                            ) :
                                <button
                                    disabled={load}
                                    style={{
                                        fontWeight: 600,
                                        backgroundColor: "#149414",
                                        borderRadius: "7px",
                                    }}
                                    className="btn-mnx"
                                    onClick={() => form.submit()}>
                                    {load ? antIcon : "Next"}
                                </button>}
                        </div>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: "end", marginBottom: 10 }}>
                        <div style={{ display: "inline-block" }}>
                            <button
                                style={{
                                    fontWeight: 600,
                                    backgroundColor: "#dc3545",
                                    borderRadius: "7px",
                                }}
                                className="btn-mnx"
                                ref={cancelBtnRef}
                                onClick={() => {
                                    props.handleCloseCallBack();
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
};

export default NewGenerateIssue;